// Module
var code = `<div ng-if="\$ctrl.show" class="inline-flex border border-harvustorange rounded-sm p-2"> <ui-link ng-if="\$ctrl.state" state="{{\$ctrl.state}}" label="{{\$ctrl.label}}"></ui-link> <span ng-if="!\$ctrl.state" class="text-sm text-harvustorange" translate="{{\$ctrl.label}}"></span> </div> `;
// Exports
export default code;